export default __webpack_public_path__ + "static/media/math-fill-blanks-blue.c7ea0166.svg";